import * as React from 'react';
import Box from '@mui/material/Box';
import {Button,Grid}  from '@mui/material';
import Privacy        from '../../privacy/Privacy';
import TermsOfService from '../../privacy/TermsOfService';
import Typography     from '@mui/material/Typography';
import Modal          from '@mui/material/Modal';
import FloatingComponent from '../../floatingcomponent/FloatComponent';
import {ArrowDownward} from '@material-ui/icons'
const style = {
  position: 'absolute',
  top: '45%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
 
  bgcolor: 'snow',
  color:'#000',
  border: '2px solid var(--app-primary)',
/*   borderTopRightRadius: 12, 
 */  borderRadius: 4, 
  boxShadow: 24,
  p: 2,
   // Responsive dimensions  
   width: {  
    xs: "98%",  // For extra-small screens  
    sm: "80%",  // For small screens  
    md: "70%",  // For medium screens  
    lg: "60%",  // For large screens  
  },  
  height: {  
    xs: "88vh", // For extra-small screens  
    sm: "65vh", // For small screens  
    md: "70vh", // For medium screens  
    lg: "75vh", // For large screens  
  },  
};

export default function Policyterms({open,setOpen,handleOpen,acceptpolicy, termsofService,privacyAction}) {  
   const actionref = React.useRef(null)
 /*  const scrollToRef = (ref) =>{
     window.scrollTo(0, ref.current.offsetTop)   
  } */
  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth',inline:'start' });
    }
  };
  
 /*  const scrollToBottom = () => {
    actionref.current?.scrollIntoView({ behavior: "smooth" })
  } */

  const handleClick = () => {

      scrollToSection("action-section")

 /* scrollToRef(actionref)
     // Add functionality for what should happen when the floating component is clicked
    // For example, scrolling to the top of the page
    window.scrollTo({ bottom: 0, behavior: 'smooth' });*/
    console.log('scroll') 
  };

  return (
    <div>
      <Modal 
        open={open}
       /*  onClose={handleClose} */
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <FloatingComponent  isVisible={true} Component={ArrowDownward} handleClick={handleClick}/>
         <Grid container justifyContent='space-between'>
          <Grid item>
             <Typography id="modal-modal-title" variant="body2" >
            Privacy Policy and Terms of Service
          </Typography></Grid>
         {/*  <Grid item onClick={()=>handleClose()}>X</Grid> */}
         </Grid>

        {
      <Grid container justifyContent='space-between'   >
         
         {  !acceptpolicy ?     
          <Grid item xs={12} marginTop={2}  sx={{height:'75vh',overflow:'scroll',border:'0px solid'}}>
                <Grid container justifyContent={'center'} alignItem='center' direction={'column'} spacing={0.5} >
                    <Grid item xs={12} >
                      <Privacy/>
                    </Grid>
                    <Grid item xs={12} >
                    <p>By clicking on agree you accepts the policy and stated above</p>
                    </Grid>
                    <Grid item  xs={12} marginBottom={4}>
                      <Grid container justifyContent={'space-around'} direction='row' alignItems={'center'}   >
                        <Grid item >
                        <Button variant='outlined' sx={{textTransform:"none"}} size='medium' onClick={()=>{privacyAction('cancel',null)}}>Cancel</Button>
                        </Grid>
                        <Grid item>
                        <Button variant='contained' sx={{textTransform:"none"}}  size='medium' onClick={()=>{privacyAction('agreed','privacy')}}>Agree</Button>

                        </Grid>
                      </Grid>
                        
                    </Grid>
                   
                </Grid>
          </Grid> :''}

          {acceptpolicy && !termsofService ? <Grid item xs={12} marginTop={2}  sx={{height:'65vh',overflow:'scroll',border:'0px solid'}}>
               
                <Grid container justifyContent={'center'} alignItem='center' direction={'column'} spacing={0.5} >
                    <Grid item xs={12} >
                      <TermsOfService/>
                    </Grid>
                    <Grid item xs={12}  >
                    <p ref={actionref}>By clicking on agree you accepts the terms of service and stated above</p>
                    </Grid>
                    <Grid   item  xs={12} marginBottom={4}>
                        <section id="action-section"> <Grid  container justifyContent={'space-around'} direction='row' alignItems={'center'}   >
                        <Grid item >

                        <Button variant='outlined'  sx={{ textTransform:'none' }}   size='medium' onClick={()=>{privacyAction('cancel',null)}}>Cancel</Button>
                        </Grid>
                        <Grid item>
                        <Button variant='contained'  sx={{textTransform:'none' }}   size='medium' onClick={()=>{privacyAction('agreed','terms')}}>Agree</Button>
                    
                        </Grid>
                      </Grid></section>
                        
                    </Grid>
                   
                </Grid>
          </Grid> :''}
          {/* <Grid item xs={12} marginTop={2} >
                <Grid container justifyContent={'center'} alignItem='center' spacing={0.5} >
                    <Grid item xs={3} >
                    </Grid>
                    <Grid item  xs={6} >
                      <Grid container justifyContent={'space-around'} direction='row' alignItems={'center'}   >
                        <Grid item >
                        </Grid>
                        <Grid item>
                         <Typography id="modal-reward-title" variant="h6" component="h2" >2X</Typography>
                        </Grid>
                      </Grid>
                        
                    </Grid>
                    <Grid item  xs={3} >
                       <Button variant='contained'>AGree</Button>
                    </Grid>
                    
                </Grid>
          </Grid> */}
       </Grid>
        }
        
        </Box>
      </Modal>
    </div>
  );
}